import { render, staticRenderFns } from "./ChoiceGrades.vue?vue&type=template&id=fa6cd054"
import script from "./ChoiceGrades.vue?vue&type=script&lang=js"
export * from "./ChoiceGrades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports